export const HASHTAG_REGEX = /\B(\#[a-zA-Z]+[a-zA-Z0-9_]*\b)/g
export const MENTION_REGEX = /\B(\@[a-zA-Z']+\b)/g

export const replaceAt = (string, index, replacer, hashtagToReplace) => {
    return (
      string.substr(0, index) +
      replacer +
      string.substr(index + hashtagToReplace.length, string.length)
    )
  }

